import React from 'react'

const ScoreInput = React.forwardRef((props, ref) => (
  <div className='score'>
    <input className='score__input' {...props} min='0' step='1' type='number' ref={ref} />
    {props.error && <div className='score__error'>{props.error.message}</div>}
  </div>
))

export default ScoreInput
